/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PoolInputs */

const cs_enum_pool = /** @type {(inputs: Enum_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazén`)
};

const en_enum_pool = /** @type {(inputs: Enum_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pool`)
};

/**
* | output |
* | --- |
* | "Pool" |
*
* @param {Enum_PoolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_pool = /** @type {((inputs?: Enum_PoolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PoolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_pool(inputs)
	return cs_enum_pool(inputs)
});